import NoDataPlaceholder from './NoDataPlaceholder'
import { HiOutlineChartBar } from 'react-icons/hi'
import { Paragraph } from '@eggplant/pattern-library'

const EmptyAvailabilityChartState = () =>
  <NoDataPlaceholder
    icon={
      <HiOutlineChartBar
        aria-hidden
        size={24}
      />
    }
    title='No monitor config severity trend data available'
  >
    <Paragraph>
      Run the selected monitor config at least once to enable monitor config severity trend data.<br />
      Try adjusting your filter selections..
    </Paragraph>
  </NoDataPlaceholder>

export default EmptyAvailabilityChartState
